import React, {useEffect, useState} from "react"
import {Button, Form, Spin} from "antd";

import {CampaignInCreate} from "types";
import FcmTopicsSelect from "components/FcmTopicsSelect";
import {FormInstance} from "antd/es/form/hooks/useForm";
import {getFcmTopicsUsersCount} from "services/campaigns";

// ----- Variables -----
const formLayout = {
    labelCol: {span: 6},
    wrapperCol: {span: 8},
};

// ----- Types -----
interface TargetStepProps {
    form: FormInstance
    campaign: CampaignInCreate | null
    loading: boolean
    setCampaign: (step: any) => void
    handleNext?: () => void
    handlePrev?: () => void
    currentStep?: number
    handleSubmit?: () => Promise<any>
}

const TargetStep: React.FC<TargetStepProps> = ({campaign, form, loading, setCampaign, handleSubmit}) => {
    // ----- form -----
    // const [form] = Form.useForm();

    // ----- State -----
    const [userCount, setUserCount] = useState<number | null>(null);
    const [userCountLoading, setUserCountLoading] = useState(false);

    // ----- Handlers -----
    const handleFinish = () => {
        handleSubmit?.()
    }

    const handleTopicsNamesChange = (value: string[]) => {
        setCampaign((currentValue: CampaignInCreate | null) => ({
            ...(currentValue ? currentValue : {}),
            topicsNames: value
        }))
    }

    const handleExcludedTopicsNamesChange = (value: string[]) => {
        setCampaign((currentValue: CampaignInCreate | null) => ({
            ...(currentValue ? currentValue : {}),
            excludedTopicsNames: value
        }))
    }

    // ----- Effects -----
    useEffect(() => {
        const fetchUserCount = async () => {
            if (!campaign?.topicsNames || campaign.topicsNames.length === 0) {
                setUserCount(null);
                return;
            }

            setUserCountLoading(true);
            try {
                const response = await getFcmTopicsUsersCount(
                    campaign.topicsNames,
                    campaign.excludedTopicsNames
                );
                setUserCount(response.data.usersCount);
            } catch (error) {
                console.error('Error fetching user count:', error);
                setUserCount(null);
            } finally {
                setUserCountLoading(false);
            }
        };

        fetchUserCount();
    }, [campaign?.topicsNames, campaign?.excludedTopicsNames]);

    return (
        <Spin spinning={loading}>
            <Form
                form={form}
                onFinish={handleFinish}
                {...formLayout}
            >
                <Form.Item
                    label="Target Audiences"
                    name="topicsNames"
                    rules={[{required: true, message: 'Please select at least one target audience!'}]}
                >
                    <FcmTopicsSelect onChange={(value: string[]) => handleTopicsNamesChange(value)}/>
                </Form.Item>
                <Form.Item
                    label="Excluded Audiences"
                    name="excludedTopicsNames"
                >
                    <FcmTopicsSelect onChange={(value: string[]) => handleExcludedTopicsNamesChange(value)}/>
                </Form.Item>
                {campaign?.topicsNames && campaign.topicsNames.length > 0 && (
                    <Form.Item
                        label="Concerned Users"
                        style={{ marginBottom: '8px' }}
                    >
                        <div style={{ color: '#666', fontSize: '14px' }}>
                            {userCountLoading ? (
                                <Spin size="small" />
                            ) : userCount !== null ? (
                                `${userCount.toLocaleString()} users will receive this campaign`
                            ) : (
                                'Calculating user count...'
                            )}
                        </div>
                    </Form.Item>
                )}
                <div style={{textAlign: 'right'}}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Spin>
    )
}

export default TargetStep